<script setup lang="ts">
const { notifications } = useNotifications();
</script>

<template>
  <aside class="fixed bottom-m inset-x-0 left-l md:left-auto right-l md:w-lg z-20">
    <TransitionGroup
      name="snackbar"
      class="flex flex-col md:gap-m"
      tag="div"
      enter-active-class="transition-all ease-in-out duration-500"
      leave-active-class="transition-all ease-in-out duration-500"
      move-class="transition-all ease-in-out duration-500"
      enter-from-class="opacity-0 translate-y-0"
      leave-to-class="opacity-0 translate-y-0"
    >
      <IadSnackBar
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
      />
    </TransitionGroup>
  </aside>
</template>
